module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15XUioT/tc-custom/9781439665077.jpg?1705026083356",
      "alt": "This image is the cover for the book Auerbach's, Landmarks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Auerbach's, Landmarks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After an arduous journey to Utah's Mormon frontier, three Jewish immigrant brothers built a flagship institution that lasted more than a century in downtown Salt Lake City. The F. Auerbach & Bros. story is one of personal challenges, Prussian folktales, perilous sea voyages, Wild West tenacity and those elegant and sophisticated fashions found on the second floor. Built along railroad tracks and dressing boomtown \"Ladies of Aristocracy\" in finery, Auerbach's tent stores evolved into one of the finest retailers in state history, providing something for everyone under one roof. Award-winning author and former Salt Lake Tribune columnist Eileen Hallet Stone brings to life the magical moments of the shopping dynasty that lasted until 1979."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eileen Hallet Stone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning author and former Salt Lake Tribune columnist Eileen Hallet Stone's projects include Historic Tales of Utah, Hidden History of Utah, A Homeland in the West: Utah Jews Remember and Missing Stories: An Oral History of Ethnic and Minority Groups in Utah, co-authored with Leslie Kelen. Her commentary is featured in the 2015 documentary film Carvalho's Journey."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0